import { render, staticRenderFns } from "./SettingListAddNew.vue?vue&type=template&id=30a06c0b&"
import script from "./SettingListAddNew.vue?vue&type=script&lang=js&"
export * from "./SettingListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./SettingListAddNew.vue?vue&type=style&index=0&id=30a06c0b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports